module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAJCAYAAADpeqZqAAAAAXNSR0IArs4c6QAAARJJREFUGBmNTr1KA0EY/GZdwUg4CWilYKe2ilgIdloppNImfc5ONrGwTKmFGqucMdholVbiXxMI6kv4CoIpxMJbb9w9OBGLkGlm59uZYSBDwjQ4nYhtC6SvhslUmpyjxM8iXHX+AHtR/AiRiRHozeMQb/9LTPS1TMEdyUkRvOQCvaVAGXOHlW/GD7VrBn9DphmvJ0Q3DQC3BaU3Dkt4V+Nab7udr6Qs9T/sjWkz54OmYXeYSMdNyrslV4V5XayF+PR/TotUW5y11j4JOSOuEcJ7IeoUKgAnp6Hed0zv9UhD/lE954JNbM81T3mdAjg42x09ymTGvyF/qLS4mFjbdZV5KJTrZX2ZGQeyuYjXTGSLg0w/TktoJ0geQ+oAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/switcher/illust-check.png
// module id = 0GJ9
// module chunks = 1